import FallbackError from '../organisms/FallbackError';

const NotFound = (): JSX.Element => {
  return <FallbackError errorCode="404" errorText="Page inconnue" />;
};

export default NotFound;
